<template>
<div class="cbs-booking-summary">
    <h2>{{ $t("forms.summary.title") }}</h2>
    <hr />

    <div class="cbs-booking-summary-general">
        <div>
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                <b>{{ $t("forms.summary.fromLabel") }}:</b>
                <span class="cbs-booking-summary-item-description">
                    {{ fromAddress }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-if="toAddress && !isHourly">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                <b>{{ $t("forms.summary.toLabel") }}:</b>
                <span class="cbs-booking-summary-item-description">
                    {{ toAddress }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-if="numberOfHours && isHourly">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-clock-o" aria-hidden="true"></i>
                <b>{{ numberOfHours }}</b>
                <span class="cbs-booking-summary-item-description">
                    {{ $tc("forms.summary.hoursLabel", numberOfHours) }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-if="selectedCar.numberOfCars && isDrivano">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-car" aria-hidden="true"></i>
                <b>{{ selectedCar.numberOfCars }}</b>
                <span class="cbs-booking-summary-item-description">
                    {{$tc("forms.summary.driversLabel", selectedCar.numberOfCars)}}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-calendar" aria-hidden="true"></i>
                <span class="cbs-booking-summary-item-label">{{ $t("forms.summary.dateTimeLabel") }}:</span>
                <span class="cbs-booking-summary-item-description">
                    {{ pickupDateTime }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-if="dropoffDateTime && isHourly">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-calendar" aria-hidden="true"></i>
                <span class="cbs-booking-summary-item-label">{{ $t("forms.summary.dropoffTimeLabel") }}:</span>
                <span class="cbs-booking-summary-item-description">
                    {{ dropoffDateTime }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-show="timeInMinutes > 0 && !isHourly">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-repeat" aria-hidden="true"></i>
                <span class="cbs-booking-summary-item-label" v-show="!isHourly">{{ $t("forms.summary.transferDurationLabel") }}:</span>
                <span class="cbs-booking-summary-item-description">
                    {{ estDuration }}</span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-show="timeInMinutes > 0 && !isHourly">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-clock-o" aria-hidden="true"></i>
                <span class="cbs-booking-summary-item-label">{{ $t("forms.summary.transferArrivalLabel") }}:</span>
                <span class="cbs-booking-summary-item-description">
                    {{ estArrivalTime }}
                </span>
            </div>
        </div>

        <hr v-if="returnDateTime != null" style="max-width: 50%" />
        <div v-if="returnDateTime != null" class="cbs-booking-summary-item mt-2">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-calendar" aria-hidden="true"></i>
                <span class="cbs-booking-summary-item-label">{{ $t("forms.summary.returnDateTimeLabel") }}:</span>
                <span class="cbs-booking-summary-item-description">
                    {{ returnDateTime }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-show="returnDateTime != null && timeInMinutes > 0 && !isHourly">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-clock-o" aria-hidden="true"></i>
                <span class="cbs-booking-summary-item-label">{{ $t("forms.summary.returnArrivalLabel") }}:</span>
                <span class="cbs-booking-summary-item-description">
                    {{ returnEstArrivalTime }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-change-section">
            <a href="#" @click.prevent="goToInitialSelection">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
                {{ $t("actions.change") }}
            </a>
        </div>
    </div>

    <div class="cbs-booking-summary-car" v-show="selectedCar.className && currentStep > 2">
        <hr />

        <div class="cbs-booking-summary-item">
            <div class="cbs-booking-summary-item-title mb-3">
                <i class="fa fa-car" aria-hidden="true"></i>
                <b>{{ $t("forms.summary.serviceLabel") }}:</b>
                <span class="cbs-booking-summary-item-description">
                    {{ selectedCar.className }}
                </span>
            </div>
            <div v-show="
            selectedCar.equivalent &&
              selectedCar.equivalent !== selectedCar.className
          " class="cbs-booking-summary-item-description">
                {{ selectedCar.equivalent }}
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-if="!this.hidePassengers">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-user" aria-hidden="true"></i> <b>Max Passengers:</b>
                <span class="cbs-booking-summary-item-description">
                    {{ selectedCar.numberOfPassengers }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-item" v-if="!this.hidePassengers">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-user" aria-hidden="true"></i> <b>Max Luggages:</b>
                <span class="cbs-booking-summary-item-description">
                    {{ selectedCar.numberOfLuggages }}
                </span>
            </div>
        </div>

        <div class="cbs-booking-summary-change-section">
            <a href="#" @click.prevent="goToCarSelection">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
                {{ $t("actions.change") }}
            </a>
        </div>
    </div>
    <div class="cbs-booking-summary-car" v-if="account && account.email">
        <hr />
        <div class="cbs-booking-summary-item">
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-user" aria-hidden="true"></i><b>{{ $t("forms.summary.accountLabel") }}:</b>
                <span class="cbs-booking-summary-item-description">{{ account.firstName }} {{ account.lastName }}</span>
            </div>
            <div class="cbs-booking-summary-item-title">
                <i class="fa fa-envelope" aria-hidden="true"></i><b>{{ $t("forms.summary.emailLabel") }}:</b>
                <span class="cbs-booking-summary-item-description">{{
            account.email
          }}</span>
            </div>
            <div class="cbs-booking-summary-item-title" v-show="selectedCar.credit">
                <i class="fa fa-credit-card" aria-hidden="true"></i><b>{{ $t("forms.summary.creditLabel") }}:</b>
                <span class="cbs-booking-summary-item-description">{{ selectedCar.credit }} {{ selectedCar.currency }}</span>
            </div>
        </div>
    </div>
    <!--<div class="cbs-booking-summary-car" v-show="selectedCar.className && currentStep > 2">
            <hr />
            <h3 class="mb-0">Add coupon:</h3>
            <input type="text" class="form-control" name="promoCode" placeholder="Cupon Code"
                    v-model="promoCode" @keyup.enter="updatePrice()">
            <div class="text-center">
                <button type="button" class="btn btn-success btn-sm apply-button" @click="updatePrice()">Apply</button>
            </div>
        </div>-->
    <div class="cbs-booking-summary-price" v-show="selectedCar.carPrice && currentStep > 2">
        <hr />
        <div class="cbs-booking-summary-item" v-if="selectedCar">
            <div class="cbs-booking-summary-item-price">
                <div>
                    <!-- <div class="clear-both">
                            <div class="item-name d-inline-block">Service:</div>
                            <div class="item-value d-inline-block float-right">
                                <span v-show="numberOfDrivers>1">{{numberOfDrivers}} x </span> {{selectedCar.initialPrice | round(2,true)}} <span v-html="selectedCar.currencySymbol"></span>
                            </div>
                        </div> -->

                    <div class="clear-both" :key="item.guid" v-for="item in selectedCar.items">
                        <div class="item-name d-inline-block" v-if="item.companyAmount > 0" v-html="item.descriptionHtml + ':'"></div>
                        <div class="item-value d-inline-block float-right" v-if="item.companyAmount > 0">
                            <span v-show="selectedCar.numberOfCars > 1">{{ selectedCar.numberOfCars }} x
                            </span>
                            <span v-show="isDrivano || item.numberOfItems > 1">{{ item.numberOfItems }} x
                            </span>
                            {{ item.companyAmount | round(2, true) }}
                            <span v-html="selectedCar.currencySymbol"></span>
                        </div>
                        <div class="clear-both" :key="extra" v-for="extra in item.extras">
                            <div class="item-name d-inline-block" v-html="extra.descriptionHtml + ':'"></div>
                            <div class="item-value d-inline-block float-right">
                                <span v-show="selectedCar.numberOfCars > 1">{{ selectedCar.numberOfCars }} x
                                </span>
                                <span v-show="isDrivano || extra.numberOfItems > 1">{{ extra.numberOfItems }} x
                                </span>
                                {{ extra.companyAmount | round(2, true) }}
                                <span v-html="selectedCar.currencySymbol"></span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="clear-both" v-show="selectedCar.discountValue > 0">
                            <div class="item-name d-inline-block">Discount:</div>
                            <div class="item-value d-inline-block float-right">
                                <span v-show="numberOfDrivers>1">{{numberOfDrivers}} x </span>
                                -{{selectedCar.discountValue | round(2,true)}} <span v-html="selectedCar.currencySymbol"></span>
                            </div>
                        </div> -->
                    <div class="clear-both" v-show="selectedCar.taxValue > 0">
                        <div class="item-name d-inline-block">Taxes:</div>
                        <div class="item-value d-inline-block float-right">
                            {{ selectedCar.taxValue | round(2, true) }}
                            <span v-html="selectedCar.currencySymbol"></span>
                        </div>
                    </div>
                </div>
                <div class="clear-both cbs-booking-summary-total-price">
                    <div class="item-name d-inline-block">
                        {{ $t("forms.summary.totalLabel") }}:
                    </div>
                    <div class="item-value d-inline-block float-right">
                        {{
                (selectedCar.numberOfCars * selectedCar.totalPrice)
                  | round(2, true)
              }}
                        <span v-html="selectedCar.currencySymbol"></span>
                    </div>
                </div>
                <div class="clear-both" v-show="selectedCar.priceToPayByAccount > 0">
                    <div class="item-name d-inline-block">
                        {{ $t("forms.summary.usingCreditLabel") }}:
                    </div>
                    <div class="item-value d-inline-block float-right">
                        {{ selectedCar.priceToPayByAccount | round(2, true) }}
                        <span v-html="selectedCar.currencySymbol"></span>
                    </div>
                </div>

                <div class="clear-both cbs-booking-summary-topay" v-show="
              selectedCar.numberOfCars * selectedCar.totalPrice !=
                selectedCar.priceToPayByCard
            ">
                    <div class="item-name d-inline-block">
                        {{ $t("forms.summary.toPayLabel") }}:
                    </div>
                    <div class="item-value d-inline-block float-right">
                        {{ selectedCar.priceToPayByCard | round(2, true) }}
                        <span v-html="selectedCar.currencySymbol"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from "moment";
import {
    round
} from "../../utils/filters.js";

export default {
    name: "BookingSummary",
    components: {},
    data: function () {
        return {};
    },
    computed: {
        isDrivano: function () {
            return this.$store.state.booking.configuration.isDrivano;
        },
        isHourly: function () {
            return this.$store.state.booking.bookingInfo.general.bookingType == 2;
        },
        hidePassengers: function () {
            return this.$store.state.booking.configuration.hidePassengers;
        },
        currentStep: function () {
            return this.$store.state.booking.bookingInfo.currentStep;
        },
        fromAddress: function () {
            var addressName = this.$store.state.booking.bookingInfo.general
                .pickupAddress.location.addressName;
            var address = this.$store.state.booking.bookingInfo.general.pickupAddress
                .location.address;
            if (address == addressName) return address;

            return addressName + " (" + address + ")";
        },
        toAddress: function () {
            var dropOffAddress = this.$store.state.booking.bookingInfo.general
                .dropOffAddress;
            if (!dropOffAddress || !dropOffAddress.location) return "";

            var addressName = this.$store.state.booking.bookingInfo.general
                .dropOffAddress.location.addressName;
            var address = this.$store.state.booking.bookingInfo.general.dropOffAddress
                .location.address;
            if (address == addressName) return address;

            return addressName + " (" + address + ")";
        },
        numberOfHours: function () {
            var numberOfHoursBooked = this.$store.state.booking.bookingInfo.general
                .durationInHours;
            return numberOfHoursBooked;
        },
        account: function () {
            var accountInfo = this.$store.state.account; //.bookingInfo.general.numberOfCars;
            if (!accountInfo.isLoggedIn) return {}; //empty object will not crash the template
            return accountInfo;
        },
        pickupDateTime: function () {
            var datePart = this.$store.state.booking.bookingInfo.general.pickupDate;
            var timePart = this.$store.state.booking.bookingInfo.general.pickupTime;
            if (!datePart || !timePart) return "";
            var parsedDate = moment(datePart + " " + timePart, "DD-MM-YYYY HH:mm");
            return parsedDate.format("DD MMM YY @ HH:mm");
        },
        returnDateTime: function () {
            if (!this.$store.state.booking.bookingInfo.general.returnPickupDate)
                return null;
            var datePart = this.$store.state.booking.bookingInfo.general
                .returnPickupDate;
            var timePart = this.$store.state.booking.bookingInfo.general
                .returnPickupTime;
            if (!datePart || !timePart) return null;
            var parsedDate = moment(datePart + " " + timePart, "DD-MM-YYYY HH:mm");
            return parsedDate.format("DD MMM YY @ HH:mm");
        },
        returnEstArrivalTime: function () {
            if (!this.$store.state.booking.bookingInfo.general.returnPickupDate)
                return null;
            var timeInMinutes = this.$store.state.booking.bookingInfo.general
                .timeInMinutes;
            var datePart = this.$store.state.booking.bookingInfo.general
                .returnPickupDate;
            var timePart = this.$store.state.booking.bookingInfo.general
                .returnPickupTime;
            if (!datePart || !timePart) return "";
            var parsedDate = moment(datePart + " " + timePart, "DD-MM-YYYY HH:mm");
            parsedDate = parsedDate.add(timeInMinutes, "minutes");
            return parsedDate.format("DD MMM YY @ HH:mm");
        },
        dropoffDateTime: function () {
            var datePart = this.$store.state.booking.bookingInfo.general.dropoffDate;
            var timePart = this.$store.state.booking.bookingInfo.general.dropoffTime;
            if (!datePart || !timePart) return "";
            var parsedDate = moment(datePart + " " + timePart, "DD-MM-YYYY HH:mm");
            return parsedDate.format("DD MMM YY @ HH:mm");
        },
        timeInMinutes: function () {
            return this.$store.state.booking.bookingInfo.general.timeInMinutes;
        },
        estDuration: function () {
            var result = "";
            var minutes = this.$store.state.booking.bookingInfo.general.timeInMinutes;
            var hours = Math.floor(minutes / 60); //hours
            if (hours > 1) result += hours + " hours ";
            else if (hours > 0) result += hours + " hour ";

            minutes = minutes - hours * 60;
            if (result.length > 0 && minutes > 0) result += " and ";

            if (minutes > 1) result += minutes + " minutes";
            else if (minutes > 0) result += minutes + " minute";

            return result;
        },
        estArrivalTime: function () {
            var timeInMinutes = this.$store.state.booking.bookingInfo.general
                .timeInMinutes;
            var datePart = this.$store.state.booking.bookingInfo.general.pickupDate;
            var timePart = this.$store.state.booking.bookingInfo.general.pickupTime;
            if (!datePart || !timePart) return "";
            var parsedDate = moment(datePart + " " + timePart, "DD-MM-YYYY HH:mm");
            parsedDate = parsedDate.add(timeInMinutes, "minutes");
            return parsedDate.format("DD MMM YY @ HH:mm");
        },
        selectedCar: {
            get: function () {
                var car = this.$store.state.booking.bookingInfo.selectedCar;
                if (!car) return {};
                return car;
            },
        },
        totalPrice: function () {
            if (!this.selectedCar.extras) return this.selectedCar.price;
            else {
                var sum = this.selectedCar.price;
                sum += this.selectedCar.extras.reduce(function (sum, item) {
                    return sum + item.companyAmount;
                }, 0);
                return sum;
            }
        },
        promoCode: {
            get: function () {
                return this.$store.state.booking.bookingInfo.general.promoCode;
            },
            set: function (value) {
                this.$store.commit("booking/setPromoCode", value);
            },
        },
    },
    methods: {
        goToCarSelection: function () {
            this.$store.commit("booking/setCurrentStep", 2);
        },
        goToInitialSelection: function () {
            this.$store.commit("booking/setCurrentStep", 1);
        },
        updatePrice: function () {
            this.$store.dispatch("booking/updateBookingPrice");
        },
    },
    filters: {
        round: round,
    },
};
</script>

<style>
.cbs-booking-summary {
    background-color: #fff;
    padding: 10px;
}

.cbs-booking-summary h2 {
    display: inline-block;
    margin-bottom: 0px;
    font-size: 18px;
}

.cbs-booking-summary a {
    text-decoration: underline;
}

.cbs-booking-summary .cbs-booking-summary-general {
    text-align: left;
}

.cbs-booking-summary .cbs-booking-summary-general,
.cbs-booking-summary .cbs-booking-summary-car,
.cbs-booking-summary .cbs-booking-summary-price {
    margin-top: 15px;
}

.cbs-booking-summary .cbs-booking-summary-item {
    margin-top: 20px;
}

.cbs-booking-summary .cbs-booking-summary-item-title {
    color: black;
    text-align: left;
}

.cbs-booking-summary .cbs-booking-summary-item-label {
    font-weight: bold;
}

.cbs-booking-summary .cbs-booking-summary-item-title i {
    padding-right: 5px;
}

.cbs-booking-summary .cbs-booking-summary-item-description {
    font-size: 14px;
    text-align: justify;
    color: black;
}

.cbs-booking-summary .cbs-booking-summary-change-section {
    text-align: right;
}

.cbs-booking-summary .cbs-booking-summary-item-price {
    color: #ab8b64;
    font-size: 16px;
    text-align: left;
}

.cbs-booking-summary .cbs-booking-summary-topay {
    margin-top: 10px;
    color: #ab8b64;
    font-size: 20px;
    text-align: left;
    font-weight: bold;
}

.cbs-booking-summary .cbs-booking-summary-total-price {
    font-weight: bold;
    border-top: 1px solid #ab8b64;
}

.cbs-booking-summary .apply-button {
    margin-top: 10px;
    background-color: #24b47e;
    box-shadow: none !important;
}

.cbs-booking-summary .cbs-booking-summary-item-price-amount {
    font-size: 28px;
}

.cbs-booking-summary .cbs-booking-summary-item-price-currency {
    margin-right: 10px;
}
</style>
